import React, { useEffect, useState, useRef, useCallback } from "react";
import { UserLazy, UserGroupsVO } from "../../../model/UserModel";
import { GetAddUsersGroup, GetAddUsersGroupName } from "../../../services/GroupsServices";
import { AddUserGroup } from "../../../services/UserServices";
import styles from "../../Style/List.module.css";
import { IIconProps, IContextualMenuProps, Stack, Link } from '@fluentui/react';
import { IconButton } from '@fluentui/react/lib/Button';
import { useTranslation } from "react-i18next";

 function useVisibility(
    cb: (isVisible: boolean) => void,
    deps: React.DependencyList
  ): (node: any) => void {
    const intersectionObserver = useRef<IntersectionObserver | null>(null);
    return useCallback((node) => {
      if (intersectionObserver.current) {
        intersectionObserver.current.disconnect();
      }
  
      intersectionObserver.current = new IntersectionObserver(([entry]) => {
        cb(entry.isIntersecting);
      });
  
      if (node) intersectionObserver.current.observe(node);
    }, deps);
  }

 interface UserGroupItemConfig {
    idUser?: string | undefined;
    idGroup?: string | undefined;
    name?: string;
    ref?: React.Ref<HTMLLIElement>;
  }

  interface ListUserGroup {
    idOrg: string;
    idGroup: string;
    name: string;
  }
  
  const GroupUsersListAdd: React.FC<ListUserGroup> = ({ idOrg,idGroup, name }) => {
    const [users, sertUsers] = useState<UserLazy[]>([]);
    let [skip, setSkip] = useState<number>(0);
    const [limit, setLimit] = useState<number>(50);
    let [userGroupMax, setUserGroupMax] = useState<boolean>(true);
    const { t, i18n } = useTranslation();
    const lastUser = useVisibility(
        (visible) => {
          if (visible) {
            if(name == ""){
              GetAddUsersGroup(idGroup, skip, limit).then((newOrg) => {
                if (newOrg.length < limit) {
                  setUserGroupMax(false);
                }
                setSkip(skip + newOrg.length);
                sertUsers([...users, ...newOrg]);
              });
            }
            else
            {
              GetAddUsersGroupName(idGroup, skip, limit, name).then((newOrg) => {
                if (newOrg.length < limit) {
                  setUserGroupMax(false);
                }
                setSkip(skip + newOrg.length);
                sertUsers([...users, ...newOrg]);
              });
            }
          }
        },
        [skip, users]
      );
    
      useEffect(() => {
        if(name == ""){
          GetAddUsersGroup(idGroup, 0, limit).then((newOrg) => {
              if (newOrg.length < limit) {
                setUserGroupMax(false);
              }
              setSkip(newOrg.length);
              sertUsers(newOrg);
            });
        }
        else
        {
          GetAddUsersGroupName(idGroup, 0, limit, name).then((newOrg) => {
            if (newOrg.length < limit) {
              setUserGroupMax(false);
            }
            setSkip(newOrg.length);
            sertUsers(newOrg);
          });
        }
      }, [name]);

    const UserGroupItem: React.ForwardRefExoticComponent<UserGroupItemConfig> =
    React.forwardRef(({ idUser, idGroup, name }, ref: React.Ref<HTMLLIElement>) => {

      const [visible, setVisible] = useState<boolean>(true);

    const add: IIconProps = {
      iconName: 'AddFriend',
      styles: {
        root: { color: 'green' }
      }
    };

    const ok: IIconProps = {
      iconName: 'Accept',
      styles: {
        root: { color: 'green' }
      }
    };

    const addClick = () => {
      let userGroupsVO:UserGroupsVO = {
        groupId:idGroup,
        userId:idUser
      }
      AddUserGroup(userGroupsVO)
      .then(() =>{
        setVisible(false);
      });
    };

      return (
          <li className={styles.itemContent} key={idUser} ref={ref}>
            {name} 
            {visible?
            (<IconButton iconProps={add} title={t("Adicionar.message")} ariaLabel={t("Adicionar.message")} onClick={addClick}/>):
            (<IconButton iconProps={ok} title="Ok" ariaLabel="Ok" />)}

        </li>
        );
    });

    return(
      <ul className={styles.ulContent} >
        {users.map((user) => (
          <UserGroupItem
            key={user.id}
            idUser={user.id}
            idGroup={idGroup}
            name={user.name}
            ref={
                users[users.length - 1].id === user.id && userGroupMax
                ? lastUser
                : null
            }
          />
        ))}
      </ul>);
  }

  export default GroupUsersListAdd;
